import Lucchini from '../../images/LUCCHINI.jpg'

const LucchiniComp:React.FC<{mobile:boolean}>=({mobile})=>{
    
    if(!mobile){return(
        <div style={{marginTop:'3vh', marginLeft:'40px'}}>
        <div style={{width:'180px', height:'180px', backgroundImage:'url("'+Lucchini+'")', backgroundSize:'cover', borderRadius:'50%', zIndex:'1', position:'absolute'}}>

        </div>
        <div style={{width:'80%',backgroundColor:'#161616', transform:'translate(50px, 20px)', zIndex:'-1', paddingBottom:'15px'}}>
            <div style={{padding:'3px 8px 3px 8px',width:'max-content', backgroundColor:'#0c76ab', marginLeft:'120px', transform:'translate(0, -50%)', color:"#fff", fontFamily:'arial black', fontSize:'12px', borderRadius:'5px', backgroundPosition:'center'}}>
                GABRIEL LUCCHINI
            </div>
            <div style={{color:'#ececec', fontFamily:'Arial Black', fontSize:'12px', textAlign:'left', marginLeft:'140px', width:'70%', lineBreak:'auto', lineHeight:'14px'}}>
                Engenheiro de gravação e mixagem e produtor musical, indicado múltiplas vezes ao LATIN GRAMMY, responsável por trabalhos com artistas como L7NNON, Japa, Ludmilla e Martinho da Vila. Tem mais de 10 anos de experiência em estúdio, além de créditos em produções de trilhas para televisão, cinema e publicidade.
            </div>
        </div>
    </div>
    )} else {
        return(
    <div style={{marginTop:'3vh', marginLeft:'0'}}>
        <div style={{float:'left', marginTop:'40px'}}>
            <div style={{width:'100px', height:'100px', backgroundImage:'url("'+Lucchini+'")', backgroundSize:'cover', borderRadius:'50%', zIndex:'1', marginLeft:'15px'}}/>
            <div style={{padding:'3px 8px 3px 8px',width:'max-content', backgroundColor:'#0c76ab',color:"#fff", fontFamily:'arial black', fontSize:'11px', borderRadius:'5px', backgroundPosition:'center', transform:'translate(0, -120%)', position:'absolute', zIndex:'1'}}>
                GABRIEL LUCCHINI
            </div>
        </div>
        <div style={{width:'40vw',backgroundColor:'#161616', transform:'translate(0px, 0px)', zIndex:'-1', paddingBottom:'15px', float:'left', color:'#ececec', fontFamily:'Arial Black', fontSize:'12px', textAlign:'left',lineBreak:'auto', lineHeight:'14px', padding:'3px 8px 3px 8px', marginLeft:'20px'}}>
            Engenheiro de gravação e mixagem e produtor musical, indicado múltiplas vezes ao LATIN GRAMMY, responsável por trabalhos com artistas como L7NNON, Japa, Ludmilla e Martinho da Vila. Tem mais de 10 anos de experiência em estúdio, além de créditos em produções de trilhas para televisão, cinema e publicidade.
        </div>
        <div style={{clear:'both'}}/>
        

    </div>
    )
    }
}

export default LucchiniComp